import { render, staticRenderFns } from "./AttacksCountByTerms.vue?vue&type=template&id=1e66bdd2&scoped=true"
import script from "./AttacksCountByTerms.vue?vue&type=script&lang=ts"
export * from "./AttacksCountByTerms.vue?vue&type=script&lang=ts"
import style0 from "./AttacksCountByTerms.vue?vue&type=style&index=0&id=1e66bdd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e66bdd2",
  null
  
)

export default component.exports